/**
 * Created by Daniela on 19/10/2016.
 */
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import {SetorFormComponent} from "./setor-form/setor-form.component";
import {editRoute, newRoute} from "../../shared/services/data.service";

@NgModule({
  imports: [
    RouterModule.forChild([])
  ],
  exports: [
    RouterModule
  ]
})
export class SetoresRoutingModule {}

export const setoresRoutes: any[] = [
  {
    path: editRoute + '/:id',
    component: SetorFormComponent
  },{
    path: newRoute,
    component: SetorFormComponent
  }
];



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/setores-routing.module.ts
 **/